import { type Validation } from '../../presentation/protocols/validation'
import { type FieldValidation } from '../../validation/protocols/field-validation'

export class ValidationComposite implements Validation {
  private readonly validators: FieldValidation[]

  constructor (validators: FieldValidation[]) {
    this.validators = validators
  }

  validate (fieldName: string, fieldValue: string, secondFieldValue?: string): string {
    const validators = this.validators.filter(v => v.field === fieldName)
    for (const validator of validators) {
      const error = validator.validate(fieldValue, secondFieldValue)
      if (error) return error.message
    }
    return ''
  }
}
